import React from 'react';
import { Mail } from 'lucide-react';
import { version } from '../../../package.json';
import { ABRECHNUNG_ANKER } from '../../administration/billing/abrechnungAnker';
import { FIRMEN_LEISTE } from '../../administration/organization/firmenLeiste';
import { ANBIETER, useRechtsLinks } from '../../config/legal';
import { VERWALTUNG_PFAD } from '../../config/verwaltungPfad';
import { useAuth } from '../../contexts/AuthContext';
import { useBrand } from '../../contexts/BrandContext';
import { Linkzeile } from '../../pages/einstellungen/Bausteine';
import { Abschnitt } from '../../pages/einstellungen/Bereich';
import { ORGANISATION_PFAD, persoenlicheAdresse, UEBER_ANKER } from '../../pages/einstellungen/seiten';
import { InfoTipp } from '../Erklaerung';
import { HILFE_TEXTE, UEBER_TEXTE, ueberUndRecht } from './hilfeTexte';

// Profil-Nachbau F-23 (PF-NB-recht-1; Nutzerblick Mitglied Z-05, Firma H-04 und H-07, Fehlersuche Nr. 8; F-06, F-16): der
// Abschnitt „Über … und Recht“ unten auf „Hilfe-Bereich › Dokumente“, Anker #ueber-clairis (UEBER_ANKER; die alte Adresse
// /einstellungen/ueber führt seit PF-NB-rahmen-2 hierher). Ersetzt Unterseiten.tsx Ueber() (Paket 08 EIN-17, AE-07).
// Gezeigt wird nur, was hinterlegt ist (AE-3a): Produkt, Version und Anbieter, die Rechtstexte mit Adresse bzw. veröffentlichter
// Fassung (neues Fenster, die Hilfe bleibt offen), „Ihre Datenschutzeinstellungen“, der Weg zum AVV je Konto und der Weg zum
// Support über „Neue Anfrage“ (die Mailadresse nur, wenn sie gültig hinterlegt ist). Was fehlt, sieht nur ein Konto mit
// Plattform-Verwaltung außerhalb einer Sicht, mit dem Weg zu „Rechtstexte“; kein anderes Konto liest eine Einrichtungsmeldung.
// F-23 (PF-NB-recht-1-nach): einen AVV-Weg gibt es nur für die Arten der Firma, deren Leiste „Verträge & AVV“ zeigt (firmenLeiste.ts
// nurFuer, PF-NB-firma-1); die interne Organisation hat keinen AVV und liest hier weder Link noch Satz. Ohne Firma (Betreiber ohne
// Platz) bleibt der Satz.
// F-24 (PF-TX-hilfe-1, SPEC-hilfe-b 3.1 D14, D15, D17): der AVV-Satz kürzer; die Linkzeile „Neue Anfrage an den Support“ entfällt
// (Hauptaktion im Seitenkopf von „Dokumente“); der Weg zu „Rechtstexte“ für den Betrieb steht im Tooltip hinter dem Hinweis.
const AVV_FUER = FIRMEN_LEISTE.flatMap(gruppe => gruppe.eintraege).find(eintrag => eintrag.key === 'vertraege')?.nurFuer;

export default function UeberClairis() {
  const brand = useBrand();
  const { user } = useAuth();
  const rechtsLinks = useRechtsLinks();
  const support = rechtsLinks.legalLinks().find(link => link.key === 'support');
  const fehlt = rechtsLinks.fehlendeRechtstexte();
  // Die Art der Firma wie FirmenSeite.tsx (PF-NB-firma-1, E-1), dieselbe Bedingung wie firmenLeiste.ts fuerArt.
  const art = user?.access?.organization?.kind ?? null;
  const avvWeg = !AVV_FUER || !art || AVV_FUER.includes(art);
  return <div id={UEBER_ANKER} className="einst-meine-anker">
    <Abschnitt titel={ueberUndRecht(brand.displayName)}>
      <dl className="einst-werte">
        <div><dt>{UEBER_TEXTE.produkt}</dt><dd>{brand.displayName}</dd></div>
        <div><dt>{UEBER_TEXTE.version}</dt><dd>{version}</dd></div>
        <div><dt>{UEBER_TEXTE.anbieter}</dt><dd>{ANBIETER}</dd></div>
      </dl>
      {rechtsLinks.hilfeRechtslinks().map(link => <Linkzeile key={link.key} href={link.href} extern>{link.label}</Linkzeile>)}
      <Linkzeile to={persoenlicheAdresse('daten')}>{HILFE_TEXTE.dokumente.datenschutz}</Linkzeile>
      {avvWeg && (user?.ebenen?.adminEinstellungen && !user.sicht?.aktiv
        ? <Linkzeile to={`${ORGANISATION_PFAD}/vertraege`}>{UEBER_TEXTE.avvFirma}</Linkzeile>
        : user?.access?.organization?.kind === 'SOLO'
          ? <Linkzeile to={`${persoenlicheAdresse('abrechnung')}#${ABRECHNUNG_ANKER.avv}`}>{UEBER_TEXTE.avvKonto}</Linkzeile>
          : <p className="einst-meine-satz">{UEBER_TEXTE.avvSatz}</p>)}
      {support && <Linkzeile href={support.href}><Mail size={16} aria-hidden="true" />{support.label}</Linkzeile>}
      {user?.ebenen?.verwaltung && !user.sicht?.aktiv && fehlt.length > 0 && <>
        <p className="adm-info" role="note">{UEBER_TEXTE.betrieb(fehlt)} <InfoTipp wort={UEBER_TEXTE.betriebWort} text={UEBER_TEXTE.betriebTipp} /></p>
        {/* Die Adresse des Leisteneintrags recht:rechtstexte (verwaltungsLeiste.ts, unterAdresse('recht', 'recht', 'rechtstexte')). */}
        <Linkzeile to={`${VERWALTUNG_PFAD}/recht?recht=rechtstexte`}>{UEBER_TEXTE.rechtstexteOeffnen}</Linkzeile>
      </>}
    </Abschnitt>
  </div>;
}
